import { AssigneeValue } from '../../components/organisms/tasks/fields';

export const byAssigneeValue = (a: AssigneeValue, b: AssigneeValue) => {
  const a_label = AssigneeValue.toString(a);
  const b_label = AssigneeValue.toString(b);

  return a_label === b_label ? 0 : a_label > b_label ? 1 : -1;
};
